import { Component, Input, ViewChild } from '@angular/core';
import { ContextMenuService, ContextMenuComponent } from 'ngx-contextmenu';
import { NavController, NavParams } from 'ionic-angular';
import { DriveServiceProvider } from '../../providers/drive-service/drive-service';
@Component({
  selector: 'page-context-menu-folder',
  templateUrl: 'context-menu-folder.html',
})
export class ContextMenuFolderPage {
  @Input() objCurrentFolderProperties: any;
  
  name = 'Angular';
  public items = [
    { name: 'John', otherProperty: 'Foo' },
    { name: 'Joe', otherProperty: 'Bar' }
  ];
  @Input() contextMenu: ContextMenuComponent;
  @ViewChild(ContextMenuComponent, { static: true }) public basicMenu: ContextMenuComponent;
  constructor(private contextMenuService: ContextMenuService, public navCtrl: NavController, public navParams: NavParams, public driveService: DriveServiceProvider) {
  }
  public onContextMenu($event: MouseEvent, item: any): void {
    this.contextMenuService.show.next({
    
      contextMenu: this.contextMenu,
      event: $event,
      item: item,
    });
    $event.preventDefault();
    $event.stopPropagation();
  }
  
  pasteFolder(e) {
   
  }

}



// WEBPACK FOOTER //
// ./src/pages/context-menu-folder/context-menu-folder.ts